export const zIndex = {
  header: 10,
  mobileNav: 12,
  mobileNavButtons: 13,
  modal: 15,
  cookieBar: 28,
  pageTransitionMask: 30,
}
